import React, { useState } from "react";
import { observer } from "mobx-react";
import CurriculumStore from "../../../../stores/CurriculumStore";
import MaterialsStore from "../../../../stores/MaterialsStore";
import { Spinner, Button, PieTimer } from "../..";
import "./ConfirmDeleteCourseProductModal.scss";

function ConfirmDeleteCourseProductModal({ product, close }) {
  const { courseId, id: productId, name: productName } = product || {};
  const { name: courseName } = CurriculumStore?.coursesById?.[courseId] || {};

  const [deleteEnabled, setDeleteEnabled] = useState(false);
  const enableDelete = () => setDeleteEnabled(true);

  const [deleting, setDeleting] = useState(false);

  const deleteCourseProduct = async () => {
    setDeleting(true);
    await MaterialsStore.deleteCourseProduct(courseId, productId);
    close();
  };

  const cancelButtonStyles = deleting ? { opacity: 0.1, pointerEvents: "none" } : {};

  const actionButtonStyles = deleting ? { opacity: 0.3, pointerEvents: "none" } : {};
  const actionButtonContent = deleting ? <Spinner /> : "Remove";
  const actionButton = deleteEnabled ? (
    <Button type="negative" action={deleteCourseProduct} style={actionButtonStyles}>
      {actionButtonContent}
    </Button>
  ) : (
    <div className="timer-container">
      <PieTimer color="var(--red)" width={24} height={24} duration={3000} onComplete={enableDelete} />
    </div>
  );

  return (
    <div className="confirm-delete-course-product-modal">
      <div className="content">
        <div className="title">
          Are you sure you want to remove {productName} from {courseName}?
        </div>
      </div>
      <div className="bottom-buttons">
        <Button action={close} style={cancelButtonStyles}>
          Cancel
        </Button>
        <div className="left-buttons">{actionButton}</div>
      </div>
    </div>
  );
}

export default observer(ConfirmDeleteCourseProductModal);
